import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import styled from 'styled-components';
import tr from 'locale';
import { Typography, Button } from '@3divi/baseui';
import { BASE_URL } from 'Config';
import formatDate from '../../FormatDate';
import SubscriptionCard from '../SubscriptionCard';
import SubscriptionManageButton from '../SubscriptionManageButton';

const Banner = styled.div`
  margin: 8px 0 12px;
  padding: 12px 16px;
  border: 1px solid ${({ theme }) => theme.border.default};
  border-radius: 4px;
  background: #ffcdd2;
`;

const BannerActions = styled.div`
  margin-top: 12px;
`;

function SubscriptionManagement({ platform = '', license = {}, loaded }) {
  const history = useHistory();
  const params = useParams();
  const currentPlatform = platform || params.platform;
  const showGraceBanner = Boolean(license.in_limited_grace || license.can_switch_provider);
  const graceDate = license.billing_grace_until
    ? formatDate(license.billing_grace_until)
    : null;

  const openBillingSwitch = () => {
    history.push(
      `${BASE_URL}/${currentPlatform}/billing-switch/?license_id=${license.id}`
    );
  };

  return (
    <>
      {showGraceBanner && (
        <Banner>
          <Typography size="14" height="20">
            {tr('billing_grace_banner', { date: graceDate || '—' })}
          </Typography>
          {license.can_switch_provider && (
            <BannerActions>
              <Button
                text={tr('billing_grace_switch_cta')}
                size="m"
                theme="contained"
                color="primary"
                onClick={openBillingSwitch}
              />
            </BannerActions>
          )}
        </Banner>
      )}
      <SubscriptionCard license={license} loaded={loaded} />
      <SubscriptionManageButton license={license} platform={currentPlatform} />
    </>
  );
}

export default SubscriptionManagement;
